import { CSSProperties, FC, MouseEventHandler, useMemo } from 'react'
import styled, { useTheme } from 'styled-components'

import PencilIcon from 'assets/svg/app/pencil.svg'
import { useAppSelector } from 'state/hooks'
import { selectIsWatcherMode } from 'state/wallet/selectors'

export type PencilButtonProps = {
	disabled?: boolean
	width?: number
	height?: number
	style?: CSSProperties
	fill?: string
	onClick?: MouseEventHandler<HTMLButtonElement> | undefined
}

const PencilButton: FC<PencilButtonProps> = ({ ...props }) => {
	const theme = useTheme()
	return (
		<PencilIconWithHover fill={theme.colors.selectedTheme.newTheme.pencilIcon.color} {...props} />
	)
}

const PencilIconWithHover = styled(PencilIcon)<{ disabled?: boolean }>`
	cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
	margin-left: 10px;
	fill: ${({ theme, disabled }) =>
		disabled
			? theme.colors.selectedTheme.newTheme.pencilIcon.hover.color
			: theme.colors.selectedTheme.newTheme.pencilIcon.color};

	&:hover {
		fill: ${({ theme }) => theme.colors.selectedTheme.newTheme.pencilIcon.hover.color};
	}
`

export const TransactionPencilButton: FC<PencilButtonProps> = ({ ...props }) => {
	const isWatcherMode = useAppSelector(selectIsWatcherMode)
	const disabled = useMemo(() => isWatcherMode || props.disabled, [isWatcherMode, props.disabled])
	return (
		<PencilButton {...props} disabled={disabled} onClick={disabled ? () => null : props.onClick} />
	)
}

export default PencilButton
